/* prettier-ignore */

import { Component, inject, input, InputSignal, ViewEncapsulation } from '@angular/core';
import { NewCustomRouteService } from '../../../../new-custom-route.service';
import { PRIMARY_TIMELINE_COLORS } from 'src/app/pages/new-custom-route/constants';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'map-select-day',
  imports: [CommonModule, TranslateModule],
  standalone: true,
  templateUrl: './select-day.component.html',
  styleUrls: ['./select-day.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})

export class SelectDayComponent {
    public days: InputSignal<any> = input.required<any>();
    public translate = inject(TranslateService);
    private routeService = inject(NewCustomRouteService);
    public primaryColors = PRIMARY_TIMELINE_COLORS;

    selectDay(day: any){
        this.routeService.setDay(day);
    }
}